<script setup>
  import Page from '@/components/Page'
  import { shareList, paymentList, footIcoList, footerInstList, getFooterList } from './footer-sub'
  import { getCurrentInstance, onMounted, ref, reactive, defineEmits, watch } from 'vue'
  import { urlCompletion } from '@/util/func'
  import { diffData, getDiffImage, getDiffData } from '@/enum/differential'
  import JLTools from '@/util/JLTools'
  import api from '@/api'
  import { useRouter, useRoute } from 'vue-router'
  import useStore from '@/store/pinia'
  const { userStore, HsystemStore } = useStore()
  const router = useRouter()
  const { proxy } = getCurrentInstance()

  watch(
    () => HsystemStore.menuData,
    (newValue, oldValue) => {
      // console.log(newValue, 'HsystemStore.menuData')
      if (newValue.length && userStore.appHomeName === 'HAIERMALL') {
        newValue.forEach((element) => {
          element.typeName = element.name
          element.id = element.id
        })
        data.footerList[0].list = newValue
      }
    }
  )

  const data = reactive({
    footerList: getFooterList()
  })

  const fooerData = getDiffData(diffData['footer'])

  // 初始化数据
  const initData = () => {
    if (userStore.appHomeName === 'HAIERMALL' && !data.footerList[0]?.list.length) {
      HsystemStore.getMenuDataList()
    }
  }

  // 处理跳转
  const handleLink = (item) => {
    if (item.id) {
      return toList(item)
    }
    if (item.url === '') return
    const url = urlCompletion(item.url)
    window.open(url, '_blank')
  }

  const toPricooPP = (type) => {
    const TERMS_CONDITIONS = `https://document.pricoo.pk/JochahoTermsConditions.html`
    const USER_PRIVACY = `https://document.pricoo.pk/JochahoPrivacyPolicy.html`
    const href = type === 'TERMS_CONDITIONS' ? TERMS_CONDITIONS : USER_PRIVACY
    window.open(href, '_blank')
  }

  const toList = (item) => {
    let num = proxy.JLTools.createCode(4)
    if (item.level == 1) {
      router.push({
        name: 'productList',
        query: {
          firstCategoryId: item.id,
          id: num
        }
      })
    } else if (item.level == 2) {
      router.push({
        name: 'productList',
        query: {
          secondCategoryId: item.id,
          id: num
        }
      })
    }
  }

  onMounted(() => {
    initData()
  })
</script>

<template>
  <div v-if="HsystemStore.menuData">
    <!-- <div class="rowBC foot-list-box">
      <div v-for="(item, index) in footerList" :key="index" class="item-box columnCC">
        <div class="foot-ico" :class="item.typeName === 'Fast Express Delivery' ? 'foot-ico01' : ''" :style="{ backgroundImage: `url(${item.image})` }"></div>
        <p class="title">{{ item.typeName }}</p>
      </div>
    </div> -->
    <div class="footer">
      <Page>
        <div class="rowBS foot-content">
          <div class="foot-left">
            <div>
              <JLImg class="haier-image" :src="getDiffImage('footLogo')" :lazy="false" :quality="100"></JLImg>
              <div class="haier-text">
                {{ getDiffImage('LogoIntroduce') }}
              </div>
            </div>
            <div class="rowSC mt20">
              <div class="rowSC kefu-box">
                <JLImg class="kefu-image" :src="footIcoList.kefuIco.urlBlack" :lazy="false"></JLImg>
                <div class="ml10 tel-box">
                  <div>Have any question?</div>
                  <div class="tel mt5">
                    {{ fooerData.tel }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="foot-right rowBS">
            <div v-for="(item, g) in data.footerList" :key="g" class="item-box columnSS">
              <div class="title">{{ item.title }}</div>
              <div v-for="(itemLink, index) in item.list" :key="index" class="item" @click.stop="handleLink(itemLink)">
                {{ itemLink.typeName }}
              </div>
            </div>
            <div class="ml50">
              <div class="title subheading-text">100% Guarantee Safe Checkout</div>
              <div class="rowSC payment-icon-box">
                <div v-for="(item, index) in paymentList" :key="index">
                  <img class="payment-selection-icon" :src="item.url" :alt="item.btnName" :style="{ width: `${item.width}px` }" />
                </div>
              </div>
              <div class="subheading-text mt30">FOLLOW US</div>
              <div class="rowSC">
                <div v-for="(item, index) in shareList()" :key="index" @click="handleLink(item)">
                  <div class="share-image mr10" :style="{ backgroundImage: `url(${item.image})` }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Page>
    </div>
    <div class="banquan-box">
      <div class="rowCC banquan-content">
        <div>{{ fooerData.name }} - © {{ fooerData.year }} All Rights Reserved</div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .footer {
    width: 100%;
    /* background: #fff; */
    background-color: var(--darkColor);
    color: var(--boxBgColor);
    padding: 25px 0;
    .foot-content {
      width: var(--minWidth);
      margin: 0 auto 20px;
      align-items: stretch;
      .foot-left {
        display: flex;
        flex-direction: column;
        flex: 0 0 255px;
        .haier-image {
          width: 170px;
          background-size: 100% 100%;
          background: transparent;
        }
        .haier-text {
          font-size: 14px;
          line-height: 24px;
          opacity: 0.5;
          text-align: justify;
        }
        .kefu-image {
          width: 50px;
          background: transparent;
        }
        .tel-box {
          min-width: 120px;
        }
        .kefu-box {
          .tel {
            /* color: var(--btnBgColor); */
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
      .item-box {
        flex-grow: 1;
        flex-basis: 0;
        height: 100%;
        margin-right: 60px;
        box-sizing: border-box;
        .title {
          font-size: 16px;
          margin: 10px 0;
          text-align: center;
          font-weight: bold;
          white-space: nowrap;
        }
        .item {
          font-size: 14px;
          opacity: 0.7;
          margin-top: 15px;
          cursor: pointer;
          white-space: nowrap;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }
  .banquan-box {
    width: 100%;
    height: 54px;
    line-height: 54px;
    font-size: 13px;
    background-color: var(--darkColor);
    color: var(--boxBgColor);
    border-top: 1px solid rgba(196, 196, 196, 1);
    .banquan-content {
      width: var(--minWidth);
      margin: 0 auto;
      .item {
        cursor: pointer;
        opacity: 0.7;
      }
    }
  }

  .foot-list-box {
    width: var(--minWidth);
    margin: 20px auto 20px;
    font-size: 16px;
    .item-box {
      /* flex-grow: 1;
      flex-basis: 0; */
      height: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      /* border-right: 1px solid #eee; */
      .title {
        margin: 10px 0;
        color: rgba(34, 34, 34, 0.87);
        text-align: center;
      }
      .introduce {
        width: 100%;
        height: 65px;
        margin-top: 10px;
        color: rgba(34, 34, 34, 0.87);
        text-align: center;
      }
      .foot-ico {
        width: 50px;
        height: 50px;
        background-size: 100%;
      }
      .foot-ico01 {
        width: 65px;
        height: 50px;
      }
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        border-right: none;
        padding-right: 0;
      }
    }
  }
  .foot-right {
    .subheading-text {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      color: #fff;
      margin: 10px 0 12px 0;
    }
    .share-image {
      width: 40px;
      height: 40px;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .payment-icon-box {
      margin: 0 8px;
      .payment-selection-icon {
        width: 16px;
        margin-right: 12px;
        vertical-align: middle;
      }
    }
  }
</style>
